import './IndustrySlide.css';
import React, { useEffect, useState } from 'react';
import { Box, Grid, List, Typography } from '@mui/material';
import IndustryCard from '../../IndustryCard/IndustryCard';
import { fetchIndustries } from '../../../backend/industries';
import { Industry } from '../../../../data_types';

const IndustrySlide = () => {
    const [industriesPerRow, setIndustriesPerRow] = useState<number>(4);
    const [industries, setIndustries] = useState<Industry[]>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadIndustry = async () => {
            try {
                const data = await fetchIndustries();
                if (data.industries && data.industriesPerRow) {
                    setIndustries(data.industries);
                    setIndustriesPerRow(data.industriesPerRow); // Dynamic update from backend
                    document.documentElement.style.setProperty('--industries-per-row', data.industriesPerRow.toString());
                } else {
                    setError('No industry data available');
                }
            } catch (error) {
                setError('Failed to fetch industries');
                console.error(error);
            }
        };
        loadIndustry();
    }, []);

    const groupIndustries = (industries: Industry[], perRow: number): Industry[][] => {
        const groupedIndustries: Industry[][] = [];
        for (let i = 0; i < industries.length; i += perRow) {
            groupedIndustries.push(industries.slice(i, i + perRow));
        }
        return groupedIndustries;
    };

    return (
        <Box className='slide' id='industries_slide'>
            <Grid className='slide_container' id='industries_slide_container' justifyContent={'center'}>
                <Grid item className='slide_content' id='slide-title'>
                    Industry
                </Grid>
                <Box className="grid-container" id="industry-grid-container">
                    {error ? (
                        <Typography variant="h6" color="error" textAlign="center">
                            {error}
                        </Typography>
                    ) : (
                        groupIndustries(industries, industriesPerRow).map((group, index) => (
                            <List key={index} className='component_container' disablePadding={true}>
                                {group.map(industry => (
                                    <IndustryCard
                                        key={industry.displayId}
                                        id={String(industry.displayId)}
                                        industryTitle={industry.industryTitle}
                                        imageUrl={industry.imageUrl}
                                        industriesPerRow={industriesPerRow}
                                        industryDescription={industry.industryDescription}
                                        link={`${process.env.REACT_APP_CLIENT_URL}/industries/${industry.displayId}`}
                                    />
                                ))}
                            </List>
                        ))
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default IndustrySlide;
